<template>
  <dialog-base
    :visible.sync="visible"
    :title="`Quản lý thành viên gói: ${packageName}`"
    size="xl"
    top="4vh"
    :use-panel="false"
    :show-footer="true"
    @cancel="handleClose"
  >
    <div class="pmd-content">
      <!-- Panel Header thông tin gói & Tổng số thành viên -->
      <div class="sk-panel mb-3">
        <div class="sk-panel-head">
          <div class="sk-panel-icon"><i class="el-icon-user" /></div>
          <div class="pmd-panel-text">
            <p class="sk-panel-title">Gói học phí: {{ packageName }}</p>
            <p class="sk-panel-subtitle">Quản lý danh sách học sinh tham gia gói và thêm mới học sinh vào gói học phí</p>
          </div>
          <div class="pmd-count-card">
            <span class="pmd-count-label">Số thành viên hiện tại</span>
            <span class="pmd-count-number">{{ paginationMembers.total }}</span>
          </div>
        </div>
      </div>

      <!-- Tabs chuyển đổi giữa Thành viên và Thêm học sinh -->
      <el-tabs v-model="activeTab" type="card" class="sk-tabs pmd-tabs" @tab-click="handleTabChange">
        
        <!-- ══════════════════════════════════════════════════════
             TAB 1: THÀNH VIÊN TRONG GÓI
             ══════════════════════════════════════════════════════ -->
        <el-tab-pane name="MEMBERS">
          <template slot="label">
            <i class="el-icon-user-solid" /> Thành viên hiện tại
          </template>

          <!-- Khung bộ lọc -->
          <div class="pmd-filter-card">
            <div class="pmd-filter-grid">
              <el-select
                v-model="searchMembers.status"
                placeholder="Trạng thái"
                clearable
                class="pmd-filter-control"
                @change="fetchMembers"
                @clear="fetchMembers"
              >
                <el-option
                  v-for="item in kidStatusList"
                  :key="item.key"
                  :value="item.key"
                  :label="item.value"
                />
              </el-select>

              <el-select
                v-model="searchMembers.idGrade"
                placeholder="Chọn khối"
                clearable
                class="pmd-filter-control pmd-filter-control--grade"
                @change="handleGradeChange('MEMBERS')"
                @clear="handleGradeChange('MEMBERS')"
              >
                <el-option
                  v-for="item in gradeList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.gradeName"
                />
              </el-select>

              <el-select
                v-model="searchMembers.idClass"
                placeholder="Chọn lớp"
                clearable
                class="pmd-filter-control pmd-filter-control--class"
                @change="fetchMembers"
                @clear="fetchMembers"
              >
                <el-option
                  v-for="item in classListMembers"
                  :key="item.id"
                  :value="item.id"
                  :label="item.className"
                />
              </el-select>

              <el-input
                v-model="searchMembers.fullName"
                placeholder="Tìm kiếm theo tên học sinh..."
                clearable
                class="pmd-search-input"
                @keyup.enter.native="fetchMembers"
                @clear="fetchMembers"
              >
                <template #append>
                  <el-button icon="el-icon-search" @click="fetchMembers" />
                </template>
              </el-input>

              <div class="pmd-spacer"></div>

              <el-button
                type="danger"
                icon="el-icon-delete"
                size="medium"
                :disabled="selectedMembers.length === 0"
                class="pmd-btn-top"
                @click="handleRemoveMembers"
              >
                Xóa đã chọn <span v-if="selectedMembers.length > 0">({{ selectedMembers.length }})</span>
              </el-button>
            </div>
          </div>

          <!-- Bảng danh sách thành viên -->
          <div class="pmd-table-wrapper">
            <el-table
              v-loading="loadingMembers"
              :data="members"
              border
              class="sk-table"
              :max-height="400"
              empty-text="Không có dữ liệu thành viên"
              @selection-change="handleMemberSelectionChange"
            >
              <el-table-column type="selection" align="center" width="50" />
              <el-table-column type="index" label="STT" width="55" align="center" />
              <el-table-column prop="fullName" label="Họ và tên" min-width="180">
                <template slot-scope="{ row }">
                  <span class="pmd-student-name">{{ row.fullName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Ngày sinh" width="120" align="center">
                <template slot-scope="{ row }">{{ row.birthDay | formatDate }}</template>
              </el-table-column>
              <el-table-column prop="className" label="Lớp học" min-width="130" />
              <el-table-column label="Ngày vào gói" width="130" align="center">
                <template slot-scope="{ row }">{{ row.enrollDate | formatDate }}</template>
              </el-table-column>
              <el-table-column label="Trạng thái" width="125" align="center">
                <template slot-scope="{ row }">
                  <el-tag :type="kidStatusTagType(row.kidStatus)" size="small" effect="light">
                    {{ kidStatusLabel(row.kidStatus) }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column label="Tác vụ" width="80" align="center" fixed="right">
                <template slot-scope="{ row }">
                  <el-tooltip content="Xóa khỏi gói" placement="top">
                    <el-button
                      type="danger"
                      size="mini"
                      circle
                      plain
                      icon="el-icon-delete"
                      @click="handleRemoveSingle(row)"
                    />
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- Phân trang -->
          <div class="pmd-pagination">
            <el-pagination
              background
              :current-page.sync="paginationMembers.page"
              :page-sizes="[25, 50, 100, 200, 500]"
              :page-size.sync="paginationMembers.size"
              :total="paginationMembers.total"
              layout="total, sizes, prev, pager, next"
              @size-change="(val) => handleSizeChange('MEMBERS', val)"
              @current-change="(val) => handlePageChange('MEMBERS', val)"
            />
          </div>
        </el-tab-pane>

        <!-- ══════════════════════════════════════════════════════
             TAB 2: THÊM HỌC SINH VÀO GÓI
             ══════════════════════════════════════════════════════ -->
        <el-tab-pane name="AVAILABLE">
          <template slot="label">
            <i class="el-icon-circle-plus-outline" /> Thêm học sinh
          </template>

          <!-- Khung bộ lọc -->
          <div class="pmd-filter-card">
            <div class="pmd-filter-grid">
              <el-select
                v-model="searchAvailable.status"
                placeholder="Trạng thái"
                clearable
                class="pmd-filter-control"
                @change="fetchAvailable"
                @clear="fetchAvailable"
              >
                <el-option
                  v-for="item in kidStatusList"
                  :key="item.key"
                  :value="item.key"
                  :label="item.value"
                />
              </el-select>

              <el-select
                v-model="searchAvailable.idGrade"
                placeholder="Chọn khối"
                clearable
                class="pmd-filter-control pmd-filter-control--grade"
                @change="handleGradeChange('AVAILABLE')"
                @clear="handleGradeChange('AVAILABLE')"
              >
                <el-option
                  v-for="item in gradeList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.gradeName"
                />
              </el-select>

              <el-select
                v-model="searchAvailable.idClass"
                placeholder="Chọn lớp"
                clearable
                class="pmd-filter-control pmd-filter-control--class"
                @change="fetchAvailable"
                @clear="fetchAvailable"
              >
                <el-option
                  v-for="item in classListAvailable"
                  :key="item.id"
                  :value="item.id"
                  :label="item.className"
                />
              </el-select>

              <el-input
                v-model="searchAvailable.fullName"
                placeholder="Tìm kiếm theo tên học sinh..."
                clearable
                class="pmd-search-input"
                @keyup.enter.native="fetchAvailable"
                @clear="fetchAvailable"
              >
                <template #append>
                  <el-button icon="el-icon-search" @click="fetchAvailable" />
                </template>
              </el-input>

              <div class="pmd-spacer"></div>

              <el-button
                type="primary"
                icon="el-icon-plus"
                size="medium"
                :disabled="selectedAvailable.length === 0"
                class="pmd-btn-top"
                @click="handleAddMembers"
              >
                Thêm vào gói <span v-if="selectedAvailable.length > 0">({{ selectedAvailable.length }})</span>
              </el-button>
            </div>
          </div>

          <!-- Bảng danh sách học sinh có thể thêm -->
          <div class="pmd-table-wrapper">
            <el-table
              v-loading="loadingAvailable"
              :data="availableStudents"
              border
              class="sk-table"
              :max-height="400"
              empty-text="Không tìm thấy học sinh phù hợp"
              @selection-change="handleAvailableSelectionChange"
            >
              <el-table-column type="selection" align="center" width="50" />
              <el-table-column type="index" label="STT" width="55" align="center" />
              <el-table-column prop="fullName" label="Họ và tên" min-width="180">
                <template slot-scope="{ row }">
                  <span class="pmd-student-name">{{ row.fullName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="Ngày sinh" width="120" align="center">
                <template slot-scope="{ row }">{{ row.birthDay | formatDate }}</template>
              </el-table-column>
              <el-table-column prop="className" label="Lớp học" min-width="130" />
              <el-table-column label="Trạng thái" width="125" align="center">
                <template slot-scope="{ row }">
                  <el-tag :type="kidStatusTagType(row.kidStatus)" size="small" effect="light">
                    {{ kidStatusLabel(row.kidStatus) }}
                  </el-tag>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <!-- Phân trang -->
          <div class="pmd-pagination">
            <el-pagination
              background
              :current-page.sync="paginationAvailable.page"
              :page-sizes="[25, 50, 100, 200, 500]"
              :page-size.sync="paginationAvailable.size"
              :total="paginationAvailable.total"
              layout="total, sizes, prev, pager, next"
              @size-change="(val) => handleSizeChange('AVAILABLE', val)"
              @current-change="(val) => handlePageChange('AVAILABLE', val)"
            />
          </div>
        </el-tab-pane>

      </el-tabs>
    </div>

    <!-- Footer Modal -->
    <template #footer>
      <div class="sk-dialog__footer">
        <el-button class="btn-cancel" plain @click="handleClose">Đóng</el-button>
      </div>
    </template>
  </dialog-base>
</template>

<script>
import DialogBase from "@/components/DialogBase.vue";
import PackageMemberService from "@/services/tutition_v3/PackageMemberService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import { kidStatusList } from "@/constant/listCommon";
import GradeService from "@/services/GradeService";
import MaClassService from "@/services/MaClassService";
import moment from "moment";

export default {
  name: "PackageMemberDialog",
  components: { DialogBase },

  data() {
    return {
      visible: false,
      idPackage: null,
      packageName: "",
      activeTab: "MEMBERS",

      gradeList: [],
      classListMembers: [],
      classListAvailable: [],
      kidStatusMap: {},
      kidStatusList,

      // Tab 1 state
      loadingMembers: false,
      members: [],
      selectedMembers: [],
      searchMembers: { status: "STUDYING", idGrade: "", idClass: "", fullName: "" },
      paginationMembers: { page: 1, size: 25, total: 0 },

      // Tab 2 state
      loadingAvailable: false,
      availableStudents: [],
      selectedAvailable: [],
      searchAvailable: { status: "STUDYING", idGrade: "", idClass: "", fullName: "" },
      paginationAvailable: { page: 1, size: 25, total: 0 },

      maxMembers: null,
    };
  },

  created() {
    kidStatusList.forEach(k => {
      this.kidStatusMap[k.key] = k.value;
    });
  },

  methods: {
    async open(pkg) {
      if (!pkg || !pkg.id) return;
      this.idPackage = pkg.id;
      this.packageName = pkg.name || "";
      this.maxMembers = pkg.maxMembers || null;
      this.activeTab = "MEMBERS";
      
      this.searchMembers = { status: "STUDYING", idGrade: "", idClass: "", fullName: "" };
      this.searchAvailable = { status: "STUDYING", idGrade: "", idClass: "", fullName: "" };
      this.classListMembers = [];
      this.classListAvailable = [];
      this.paginationMembers.page = 1;
      this.paginationMembers.total = 0;
      this.paginationAvailable.page = 1;
      this.paginationAvailable.total = 0;
      this.selectedMembers = [];
      this.selectedAvailable = [];

      this.visible = true;
      if (this.gradeList.length === 0) {
        await this.getAllGrade();
      }
      this.fetchMembers();
    },

    handleClose() {
      this.visible = false;
      this.idPackage = null;
      this.members = [];
      this.availableStudents = [];
      this.$emit("closed");
    },

    async getAllGrade() {
      if (!this.visible || !this.idPackage) return;
      try {
        const resp = await GradeService.getGradeInPrinciple();
        this.gradeList = resp.data.data || [];
      } catch (err) {
        console.error(err);
      }
    },

    async loadClassList(tab) {
      if (!this.visible || !this.idPackage) return;
      const targetGrade = tab === 'MEMBERS' ? this.searchMembers.idGrade : this.searchAvailable.idGrade;
      
      // Nếu xóa chọn khối (trạng thái clearable/trống) -> tải toàn bộ theo các bộ lọc khác
      if (!targetGrade) {
        if (tab === 'MEMBERS') {
          this.classListMembers = [];
          this.searchMembers.idClass = "";
          this.fetchMembers();
        } else {
          this.classListAvailable = [];
          this.searchAvailable.idClass = "";
          this.fetchAvailable();
        }
        return;
      }

      // Có chọn khối -> tải danh sách lớp của khối đó
      try {
        const resp = await MaClassService.getClassInGrade(targetGrade);
        const list = resp.data && resp.data.data ? resp.data.data : [];
        if (tab === 'MEMBERS') {
          this.classListMembers = list;
          if (list.length > 0) {
            this.searchMembers.idClass = list[0].id;
            this.fetchMembers();
          } else {
            // Không có lớp tương ứng trong khối -> KHÔNG gọi API về BE
            this.searchMembers.idClass = "";
            this.members = [];
            this.paginationMembers.total = 0;
          }
        } else {
          this.classListAvailable = list;
          if (list.length > 0) {
            this.searchAvailable.idClass = list[0].id;
            this.fetchAvailable();
          } else {
            // Không có lớp tương ứng trong khối -> KHÔNG gọi API về BE
            this.searchAvailable.idClass = "";
            this.availableStudents = [];
            this.paginationAvailable.total = 0;
          }
        }
      } catch (err) {
        console.error(err);
      }
    },

    handleGradeChange(tab) {
      this.loadClassList(tab);
    },

    handleTabChange(tab) {
      if (!this.visible || !this.idPackage) return;
      if (tab.name === 'MEMBERS') {
        if (this.searchMembers.idGrade && this.classListMembers.length === 0) {
          this.members = [];
          this.paginationMembers.total = 0;
        } else {
          this.fetchMembers();
        }
      } else if (tab.name === 'AVAILABLE') {
        if (this.searchAvailable.idGrade && this.classListAvailable.length === 0) {
          this.availableStudents = [];
          this.paginationAvailable.total = 0;
        } else {
          this.fetchAvailable();
        }
      }
    },

    // ─── Tab 1: Members ──────────────────────────────────────────
    async fetchMembers() {
      if (!this.visible || !this.idPackage) return;
      this.loadingMembers = true;
      try {
        const params = {
          idPackage: this.idPackage,
          idClass: this.searchMembers.idClass || undefined,
          status: this.searchMembers.status || undefined,
          fullName: this.searchMembers.fullName || undefined,
          page: this.paginationMembers.page - 1,
          size: this.paginationMembers.size,
        };
        const res = await PackageMemberService.getMembers(params);
        this.members = res.data.data || [];
        this.paginationMembers.total = res.data.total || 0;
      } catch (err) {
        NotifyMessage.leftCornerNotificationError("Lỗi khi tải thành viên gói");
      } finally {
        this.loadingMembers = false;
      }
    },

    handleMemberSelectionChange(val) {
      this.selectedMembers = val;
    },

    handleRemoveSingle(row) {
      this.selectedMembers = [row];
      this.handleRemoveMembers();
    },

    async handleRemoveMembers() {
      if (!this.selectedMembers.length) return;
      
      const confirm = await this.$confirm(
        "Bạn có chắc chắn muốn xóa học sinh đã chọn khỏi gói? Dữ liệu các khoản thu đã đăng ký và hóa đơn trước đó sẽ được giữ nguyên hoặc cập nhật tùy chọn.",
        "Xác nhận xóa học sinh khỏi gói",
        {
          confirmButtonText: "Xác nhận xóa",
          cancelButtonText: "Hủy bỏ",
          type: "warning",
        }
      ).catch(() => false);

      if (!confirm) return;

      const studentIds = this.selectedMembers.map(m => m.idStudent);
      try {
        await PackageMemberService.removeMembers({
          idPackage: this.idPackage,
          studentIds,
          deleteRevenue: true
        });
        NotifyMessage.leftCornerNotificationSuccess("Xóa học sinh khỏi gói thành công!");
        this.fetchMembers();
      } catch (err) {
        NotifyMessage.leftCornerNotificationError(err?.response?.data?.message || "Xóa thất bại!");
      }
    },

    // ─── Tab 2: Available ────────────────────────────────────────
    async fetchAvailable() {
      if (!this.visible || !this.idPackage) return;
      this.loadingAvailable = true;
      try {
        const params = {
          idPackage: this.idPackage,
          idClass: this.searchAvailable.idClass || undefined,
          status: this.searchAvailable.status || undefined,
          fullName: this.searchAvailable.fullName || undefined,
          page: this.paginationAvailable.page - 1,
          size: this.paginationAvailable.size,
        };
        const res = await PackageMemberService.getAvailableStudents(params);
        this.availableStudents = res.data.data || [];
        this.paginationAvailable.total = res.data.total || 0;
      } catch (err) {
        NotifyMessage.leftCornerNotificationError("Lỗi khi tải danh sách học sinh");
      } finally {
        this.loadingAvailable = false;
      }
    },

    handleAvailableSelectionChange(val) {
      this.selectedAvailable = val;
    },

    async handleAddMembers() {
      if (!this.selectedAvailable.length) return;
      
      if (this.maxMembers && (this.paginationMembers.total + this.selectedAvailable.length > this.maxMembers)) {
        NotifyMessage.leftCornerNotificationError(`Không thể thêm. Gói học phí chỉ cho phép tối đa ${this.maxMembers} thành viên!`);
        return;
      }

      const studentIds = this.selectedAvailable.map(s => s.idStudent);
      const enrollDate = moment().format("YYYY-MM-DD");

      try {
        const res = await PackageMemberService.addMembers({
          idPackage: this.idPackage,
          studentIds,
          enrollDate
        });
        const data = res.data.data || {};
        NotifyMessage.leftCornerNotificationSuccess(`Đã thêm ${data.addedCount || 0} học sinh vào gói.`);
        this.fetchAvailable();
        // Cập nhật lại số lượng và danh sách bên tab Members nếu người dùng quay lại
        this.fetchMembers();
      } catch (err) {
        NotifyMessage.leftCornerNotificationError(err?.response?.data?.message || "Thêm thất bại!");
      }
    },

    // ─── Helpers ────────────────────────────────────────────────
    handleSizeChange(tab, size) {
      if (tab === "MEMBERS") {
        this.paginationMembers.size = size;
        this.paginationMembers.page = 1;
        this.fetchMembers();
      } else {
        this.paginationAvailable.size = size;
        this.paginationAvailable.page = 1;
        this.fetchAvailable();
      }
    },

    handlePageChange(tab, page) {
      if (tab === "MEMBERS") {
        this.paginationMembers.page = page;
        this.fetchMembers();
      } else {
        this.paginationAvailable.page = page;
        this.fetchAvailable();
      }
    },

    kidStatusLabel(status) {
      return this.kidStatusMap[status] || status;
    },

    kidStatusTagType(status) {
      if (status === "STUDYING") return "success";
      if (status === "STUDY_WAIT") return "warning";
      if (status === "RESERVE") return "info";
      if (status === "LEAVE_SCHOOL") return "danger";
      return "";
    }
  },

  filters: {
    formatDate(value) {
      if (!value) return "—";
      return moment(value).format("DD/MM/YYYY");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-dialog";
@import "@/assets/style/sk-table";

/* =====================================================
   PackageMemberDialog – Prefix: pmd-
   Tuân thủ tiêu chuẩn OneKids V3 Guidelines
   ===================================================== */

.pmd-content {
  margin-top: -6px;
}

.pmd-panel-text {
  flex: 1;
  min-width: 0;
  word-break: break-word;
  overflow-wrap: break-word;

  .sk-panel-title,
  .sk-panel-subtitle {
    word-break: break-word;
    overflow-wrap: break-word;
    white-space: normal;
  }
}

/* ─── Card số lượng thành viên ở header ───────────── */
.pmd-count-card {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 10px;
  padding: 6px 14px;
  flex-shrink: 0;
}

.pmd-count-label {
  font-size: 11.5px;
  color: #64748b;
  font-weight: 500;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: break-word;
  text-align: right;
}

.pmd-count-number {
  font-size: 18px;
  font-weight: 700;
  color: #2563eb;
  line-height: 1.2;
}

/* ─── Tabs Style chuẩn Guidelines ──────────────────── */
/deep/ .pmd-tabs .el-tabs__nav {
  background: transparent;
  border: none;
}
/deep/ .pmd-tabs .el-tabs__nav-wrap::after {
  background: #2563eb;
  height: 2px;
}
/deep/ .pmd-tabs .el-tabs__item {
  background: #e5e7eb;
  color: #4b5563;
  font-weight: 600;
  border: 1px solid #d1d5db !important;
  border-bottom: none !important;
  border-radius: 8px 8px 0 0;
  transition: background 0.15s, color 0.15s;
  i { margin-right: 6px; }
}
/deep/ .pmd-tabs .el-tabs__item:hover:not(.is-active) {
  background: #d1d5db;
  color: #1e293b;
}
/deep/ .pmd-tabs .el-tabs__item.is-active {
  color: #ffffff !important;
  background: #2563eb !important;
  border-color: #2563eb !important;
}
/deep/ .pmd-tabs .el-tabs__header {
  margin-bottom: 14px;
}

/* ─── Khung Filter Card ───────────────────────────── */
.pmd-filter-card {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px 14px;
  margin-bottom: 14px;
}

.pmd-filter-grid {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.pmd-filter-control         { width: 140px; }
.pmd-filter-control--grade  { width: 140px; }
.pmd-filter-control--class  { width: 150px; }
.pmd-search-input           { width: 260px; }

.pmd-spacer {
  flex: 1;
}

.pmd-btn-top {
  border-radius: 8px;
  font-weight: 600;
}

/* ─── Table Wrapper & Header ───────────────────────── */
.pmd-table-wrapper {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.03);
}

.pmd-student-name {
  font-weight: 600;
  color: #1e293b;
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

/* Header Table màu xanh Primary */
/deep/ .sk-table thead th,
/deep/ .sk-table thead td {
  background: #2563eb !important;
  color: #ffffff !important;
  font-weight: 700;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
/deep/ .sk-table thead th > .cell,
/deep/ .sk-table thead td > .cell {
  color: #ffffff !important;
  font-weight: 700;
  white-space: normal !important;
  word-break: break-word !important;
  overflow-wrap: break-word !important;
  line-height: 1.3 !important;
}
/deep/ .sk-table thead tr { height: 46px; }
/deep/ .sk-table tbody td { background: #ffffff; }
/deep/ .sk-table tbody td > .cell {
  white-space: normal !important;
  word-break: break-word !important;
  overflow-wrap: break-word !important;
  line-height: 1.4 !important;
}
/deep/ .sk-table .el-tag {
  white-space: normal !important;
  height: auto !important;
  line-height: 1.3 !important;
  padding: 4px 8px !important;
  word-break: break-word !important;
  display: inline-block;
}

/* ─── Phân trang ───────────────────────────────────── */
.pmd-pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 14px;
}

/* ─── Controls bo góc theo OneKids V3 ─────────────── */
/deep/ .pmd-content .el-input__inner,
/deep/ .pmd-content .el-select .el-input__inner {
  border-radius: 8px;
}
/deep/ .pmd-content .el-button {
  border-radius: 8px;
}
/deep/ .pmd-content .el-input-group__append .el-button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
</style>
